import * as React from "react";
import CircleContainer from "./CircleContainer";
import Typography from "@material-ui/core/Typography";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useStopwatch } from "react-timer-hook";
import { Fonts } from "core/utils/Fonts";
import { Colors } from "core/utils/Colors";
import { MAX_TOGGLE_FONT_SIZE, MAX_BUTTON_FONT_SIZE } from "./Timer";
import { Grid, Button, Tooltip, IconButton } from "@material-ui/core";
import { strings } from "core/localizedStrings";
import * as Icons from "core/utils/Icons";

export interface StopwatchProps extends React.Props<any> {
    size: number;
}

const Stopwatch = (props: StopwatchProps) => {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            stopwatchFont: {
                fontFamily: Fonts.Roboto,
                color: Colors.darkGrey,
                fontSize: props.size * 0.18,
            },
            toggle: {
                fontSize: Math.min(props.size * 0.03, MAX_TOGGLE_FONT_SIZE),
                padding: 4,
            },
            button: {
                fontSize: Math.min(props.size * 0.06, MAX_BUTTON_FONT_SIZE),
            },
            iconButton: {
                padding: props.size * 0.005,
                margin: props.size * 0.005,
                backgroundColor: "rgb(255,255,255,0.1)",
            },
            flipContainer: {
                padding: props.size * 0.04,
            },
        })
    );
    const { seconds, minutes, hours, isRunning, start, pause, reset } = useStopwatch({ autoStart: false });
    const minsString = minutes > 9 ? minutes : `0${minutes}`;
    const secondsString = seconds > 9 ? seconds : `0${seconds}`;
    const timeString = hours > 0 ? `${hours}:${minsString}:${secondsString}` : `${minsString}:${secondsString}`;
    var styles = useStyles();

    return (
        <Grid container>
            <CircleContainer key="back" size={props.size}>
                <Typography className={styles.stopwatchFont}>{timeString}</Typography>
            </CircleContainer>
            <Grid container style={{ paddingTop: props.size * 0.05 }}>
                <Grid item xs={3}>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Tooltip title={strings.reset} placement="bottom">
                                <IconButton onClick={reset} className={styles.iconButton}>
                                    <Icons.Replay />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container justify="center" alignContent="center" style={{ height: "100%" }}>
                        <Grid item style={{ width: "100%" }}>
                            {!isRunning ? (
                                <Button
                                    variant="contained"
                                    fullWidth={true}
                                    color="secondary"
                                    className={styles.button}
                                    onClick={start}
                                >
                                    {strings.start}
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    fullWidth={true}
                                    color="secondary"
                                    className={styles.button}
                                    onClick={pause}
                                >
                                    {strings.pause}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}></Grid>
            </Grid>
        </Grid>
    );
};

export default Stopwatch;
